import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { App } from './App';
import { reportWebVitals } from './reportWebVitals';
import { persistor, store } from './store';
import { clearPersistedSessionIfTabClosed } from './utils/auth-session-cleanup';
import { applyFaviconFromCache, applyFontFromCache } from './utils/brand-cache';

// Apply cached brand values synchronously before React mounts.
// Font must run first so the <style> tag is in <head> before the favicon swap.
// Both are no-ops on first-ever load when no cache exists yet.
applyFontFromCache(); // Eliminates font-family flash (FOUT)
applyFaviconFromCache(); // Eliminates favicon spinner flash
clearPersistedSessionIfTabClosed();

export const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                {/* <ApolloProvider client={client}> */}
                <BrowserRouter>
                    <App />
                </BrowserRouter>
                {/* </ApolloProvider> */}
            </PersistGate>
        </Provider>
    </React.StrictMode>,
);

reportWebVitals(console.warn);
